import { render, staticRenderFns } from "./extra-style-template.vue?vue&type=template&id=23324cd5&scoped=true&"
import script from "./extra-style-template.vue?vue&type=script&lang=js&"
export * from "./extra-style-template.vue?vue&type=script&lang=js&"
import style0 from "./extra-style-template.vue?vue&type=style&index=0&id=23324cd5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23324cd5",
  null
  
)

export default component.exports